import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", fontFamily: "system-ui", fontSize: "14px" }}>
          <h1 style={{ color: "red", fontSize: "18px", marginBottom: "1rem" }}>
            App Crash
          </h1>
          <pre style={{ whiteSpace: "pre-wrap", color: "red", marginBottom: "1rem" }}>
            {this.state.error?.toString()}
          </pre>
          <details open>
            <summary style={{ cursor: "pointer", fontWeight: "bold", marginBottom: "0.5rem" }}>
              Component Stack
            </summary>
            <pre style={{ whiteSpace: "pre-wrap", color: "#666", fontSize: "12px" }}>
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}